import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { scrollToTop } from "libs/helpers/ScrollToTop";

const usePagination = (data, perPage) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const filters = queryString.parse(search);
  const totalItems = data?.length || 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / perPage));

  const rawPage = parseInt(filters.page, 10);
  let currentPage;
  if (!filters.page || isNaN(rawPage) || rawPage <= 0) {
    currentPage = 1;
  } else if (rawPage > totalPages) {
    currentPage = totalPages;
  } else {
    currentPage = rawPage;
  }

  useEffect(() => {
    if (!data) return;

    const raw = parseInt(filters.page, 10);

    if (filters.page !== undefined && (isNaN(raw) || raw <= 0)) {
      const { page: _removed, ...rest } = filters;
      navigate(`?${queryString.stringify(rest)}`, { replace: true });
    } else if (!isNaN(raw) && raw > totalPages) {
      navigate(`?${queryString.stringify({ ...filters, page: totalPages })}`, {
        replace: true,
      });
    }
  }, [data, filters, navigate, totalPages]);

  const handlePageChange = (page) => {
    const newFilters = { ...filters };
    if (page <= 1) {
      delete newFilters.page;
    } else {
      newFilters.page = page;
    }
    navigate(`?${queryString.stringify(newFilters)}`);
    scrollToTop();
  };

  const paginatedData = data
    ? data.slice((currentPage - 1) * perPage, currentPage * perPage)
    : [];

  return { currentPage, totalPages, handlePageChange, paginatedData };
};

export default usePagination;
